<template>
  <v-list class="courses-list py-0">
    <div v-for="(item, index) in treeItems" :key="item.id">
      <v-list-item
        ><!--class="hoverable"-->
        <v-list-item-icon class="mr-2">
          <v-btn icon :class="{ hidden: !item.children }" @click="showSubElements[item.id] = !showSubElements[item.id]">
            <v-icon>{{ showSubElements[item.id] ? 'mdi-menu-down' : 'mdi-menu-right' }} </v-icon>
          </v-btn>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content class="item">
          <!--@click="onItemDisplay(item, index)"-->
          <v-list-item-title>{{ item.name }}<strong v-if="item.isRequired"> *</strong></v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <ViewableCourseTree
        v-if="item.isModule"
        :style="{ display: showSubElements[item.id] ? 'block' : 'none' }"
        :items="item.children || []"
        :nest-level="nestLevel + 1"
        :nest-order="index"
        :path="[...path, index]"
        :course-id="courseId"
        :parent-id="item.id"
      />
    </div>
  </v-list>
</template>

<script>
export default {
  name: 'ViewableCourseTree',
  props: {
    items: {
      type: Array,
      required: true
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    nestOrder: {
      type: Number,
      default: 0
    },
    path: {
      type: Array,
      default: () => []
    },
    courseId: {
      type: Number,
      required: true
    },
    parentId: {
      validator: prop => typeof prop === 'number' || prop === null,
      required: true
    }
  },
  data: function() {
    return {
      showSubElements: this.items.reduce((map, element) => {
        map[element.id] = true;
        return map;
      }, {})
    };
  },
  computed: {
    treeItems: {
      get() {
        return this.items;
      },
      set() {
        // items are updated in store
      }
    }
  },
  watch: {
    items() {
      this.showSubElements = this.items.reduce((map, element) => {
        map[element.id] = true;
        return map;
      }, {});
    }
  },
  methods: {
    // onItemDisplay(element, index) {
    //   // TODO?
    // }
  }
};
</script>

<style lang="scss" scoped>
.hidden {
  visibility: hidden;
}

.draggable {
  outline: 1px solid rgba(0, 0, 0, 0.12);
  min-height: 3rem;
}

.hoverable {
  padding-left: 4px;
  padding-right: 4px;

  .item {
    cursor: pointer;
  }
}

@mixin nestingPadding($step: 32px, $maxStep: 192px) {
  .courses-list .courses-list {
    padding-left: $step;
    @if $maxStep >= $step {
      // exit
    } @else {
      @include opacityStair($step * 2, $maxStep);
    }
  }
}

/* more nesting? */
@include nestingPadding(32px, 640px);
</style>
